import React, { Component } from 'react';
import { Flex, List } from 'antd-mobile';
import { Link } from "react-router-dom";
const Item = List.Item;
export class HospitalItems extends Component {
    //页面初渲染时
    componentDidMount() {
    }
    render() {
        const hospitalData = this.props.hospitalData;

        return (<div className="items">
            {
                (Object.keys(hospitalData)).length === 0 ? '' :
                    <Item
                        arrow="horizontal"
                        multipleLine
                    >
                       <Link to={`/hospital/details/${this.props.hospitalData.mcno}`} >
                            <Flex align="start">
                                {
                                     (Object.keys(hospitalData.mcLogo)).length !== 0 ? <img src={hospitalData.mcLogo[0].picpath} alt="" />
                                        : <img src={require('../../res/images/h_zw.jpg')} alt="" />
                                }
                                <div className="items__right">
                                    <p style={{ color: "#000" }}>{hospitalData.mcname}</p>
                                    <span>{hospitalData.address}</span>
                                </div>
                            </Flex>
                        </Link> 
                    </Item>
            }
        </div>);
    }

}